import { ReactElement, ReactNode } from "react";
import { formatDate } from "../util/general";
import "./InnerCard.scss";

type IconWithText = {
  icon: ReactElement;
  isIconHighlighted?: boolean;
  text: string;
};

type InnerCardProps = {
  className?: string;
  children?: {
    header?: ReactNode | IconWithText;
    content?: ReactNode;
  };
};

export default function InnerCard(props: InnerCardProps): ReactElement {
  const content = props?.children?.content;
  const headerText = (props?.children?.header as IconWithText)?.text;

  return (
    <div className={"inner-card " + (props.className || "")}>
      {renderCardHeader(props?.children?.header)}
      {content !== undefined && headerText === "Analysis Timestamp" ? (
        <span>{formatDate(content as string)}</span>
      ) : headerText === "Processing time" ? (
        <span>
          {(parseInt((content as string).slice(0, -3)) / 1000).toFixed(2)}{" "}
          seconds
        </span>
      ) : (
        <>{content}</>
      )}
    </div>
  );
}

function renderCardHeader(header: ReactNode | IconWithText): ReactNode {
  if (isOfTypeIconWithText(header)) {
    return (
      <>
        <div className="flex-row-with-vertical-alignment">
          <span
            className={
              "inner-card-header-icon" +
              ((header as IconWithText).isIconHighlighted ? " highlighted" : "")
            }
          >
            {(header as IconWithText).icon}
          </span>
          <span className="inner-card-header-text">
            {(header as IconWithText).text}
          </span>
        </div>
      </>
    );
  } else {
    // If nor an icon with a text, rendering the header as JSX
    return header as ReactNode;
  }
}

// A "type guard" for checking whether an object is of type IconWithText
function isOfTypeIconWithText(
  obj: ReactNode | IconWithText,
): obj is IconWithText {
  return (
    (obj as IconWithText).icon !== undefined &&
    (obj as IconWithText).text !== undefined &&
    (Object.keys(obj as object).length === 2 ||
      (Object.keys(obj as object).length === 3 &&
        (obj as IconWithText).isIconHighlighted !== undefined))
  );
}
